import React from 'react';
import './CSS/Contact.css';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

// Icono personalizado para el marcador
const clinicIcon = new L.Icon({
  iconUrl: '/assets/images/map-pin.png',
  iconSize: [35, 45],
  iconAnchor: [17, 45],
  popupAnchor: [0, -45]
});

function Contact() {
  const clinicLocation = [40.40687, -3.89577];

  return (
    <section id="contact" className="contact-section">
      <h1>Contáctanos</h1>
      <h2>Until one has loved an animal, a part of one's soul remains unaweakened</h2>
      <h3>Puedes contactarnos llamando al +34 607 18 88 25, al +34 916 336 404 o enviando un email a ayavet@ayavet.com</h3>

      {/* Mapa de Leaflet */}
      <div className="map-container">
        <MapContainer center={clinicLocation} zoom={13} scrollWheelZoom={false} style={{ height: '400px', width: '100%' }}>
          <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          />
          <Marker position={clinicLocation} icon={clinicIcon}>
            <Popup>
              Nuestra clínica está aquí.
            </Popup>
          </Marker>
        </MapContainer>
      </div>
    </section>
  );
}

export default Contact;